import {
  AfterViewInit,
  Component,
  OnInit,
  ViewChild,
  inject,
} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthService} from '../services/auth.service';
import {MatSidenav, MatSidenavModule} from '@angular/material/sidenav';
import {FilterDrawerService} from '../services/filter-drawer.service';
import {FilterDrawerComponent} from './filters/filter-drawer/filter-drawer.component';
import {CaregiverManagementDashboardTitleComponent} from './caregiver-management-dashboard-title/caregiver-management-dashboard-title.component';
import {FilterDateSelectionDisplayComponent} from './filters/filter-date-selection-display/filter-date-selection-display.component';
import {FilterToggleCurrentSelectionsContainerComponent} from './filters/filter-toggle-current-selections-container/filter-toggle-current-selections-container.component';
import {CaregiverManagementDashboardChartContainerComponent} from './charts/caregiver-management-dashboard-chart-container/caregiver-management-dashboard-chart-container.component';
import {CaregiverPerformanceGridContainerComponent} from './grid/caregiver-performance-grid-container/caregiver-performance-grid-container.component';

@Component({
  selector: 'app-caregiver-management-dashboard',
  templateUrl: './caregiver-management-dashboard.component.html',
  styleUrls: ['./caregiver-management-dashboard.component.scss'],
  standalone: true,
  imports: [
    MatSidenavModule,
    FilterDrawerComponent,
    CaregiverManagementDashboardTitleComponent,
    FilterDateSelectionDisplayComponent,
    FilterToggleCurrentSelectionsContainerComponent,
    CaregiverManagementDashboardChartContainerComponent,
    CaregiverPerformanceGridContainerComponent,
  ],
})
export class CaregiverManagementDashboardComponent
  implements OnInit, AfterViewInit {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private authService = inject(AuthService);
  filterDrawerService = inject(FilterDrawerService);

  @ViewChild(MatSidenav) filterDrawer: MatSidenav | undefined;

  ngOnInit() {
    this.handleTokenFromUrl();
    this.subscribeToFilterDrawerChanges();
  }

  ngAfterViewInit() {
    this.registerDrawer();
  }

  private handleTokenFromUrl(): void {
    const tokenValue = this.route.snapshot.queryParamMap.get('token');
    if (tokenValue) {
      this.authService.setAccessToken(tokenValue);
      this.router.navigate(['.'], {relativeTo: this.route, queryParams: {}});
    }
  }

  private registerDrawer() {
    this.filterDrawerService.register(this.filterDrawer);
  }

  private subscribeToFilterDrawerChanges(): void {
    this.filterDrawerService.toggleChange$.subscribe(() =>
      this.filterDrawer.toggle()
    );
  }
}
